export const CREATE_EVENT_PLANNER =
  'line-up/event-planner/CREATE_EVENT_PLANNER';
export const UPDATE_EVENT_PLANNER =
  'line-up/event-planner/UPDATE_EVENT_PLANNER';
export const FETCH_EVENT_PLANNER = 'line-up/event-planner/FETCH_EVENT_PLANNER';
export const DELETE_EVENT_PLANNER =
  'line-up/event-planner/DELETE_EVENT_PLANNER';
